// extracted by mini-css-extract-plugin
export default {"drawer":"index_drawer__fjwHC","open":"index_open__lPovL","close":"index_close__LltQp","drawer-mask":"index_drawer-mask__FR3+K"};